<template>
  <section
    class="mem-coupons"
    data-ui="mem-coupons"
  >
    <CdrText
      class="mem-coupons__heading"
      tag="h2"
    >
      {{ heading }}
    </CdrText>
    <CdrText
      class="mem-coupons__subheading"
      tag="p"
    >
      {{ subheading }}
    </CdrText>
    <ul class="mem-coupons__coupons">
      <li
        v-for="coupon in coupons"
        :key="coupon?.key"
        class="mem-coupons__coupon coupon"
      >
        <div class="coupon__image-container">
          <CdrImg
            class="coupon__image"
            :alt="coupon?.image?.alt"
            :src="coupon?.image?.src"
          />
          <CdrImg
            v-if="coupon?.couponImage"
            class="coupon__coupon-image"
            role="presentation"
            alt=""
            :src="coupon?.couponImage?.src"
          />
          <span class="sr-only">{{ coupon?.couponImage.alt }}</span>
          <div class="coupon__rights-container">
            <CdrImg
              v-if="coupon?.couponImage"
              class="coupon__rights-image"
              role="presentation"
              alt=""
              src="https://www.rei.com/dam/20055469_mem_member_attribution_camera-icon-white_hex.svg"
            />
            <CdrText
              v-if="coupon?.image?.rights"
              tag="p"
              class="coupon__rights-text"
            >
              {{ coupon?.image?.rights }}
            </CdrText>
          </div>
        </div>
        <CdrText
          tag="h3"
          class="coupon__heading"
        >
          {{ coupon?.heading }}
        </CdrText>
        <p
          class="coupon__body"
          v-html="coupon?.body"
        />
        <cdr-button
          v-if="coupon?.cta"
          :data-analytics-id="`membership:coupon_${coupon?.cta?.text}`"
          :href="coupon?.cta?.target"
          class="coupon__cta"
          modifier="primary"
          tag="a"
        >
          {{ coupon?.cta?.text }}
        </cdr-button>
      </li>
    </ul>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { CdrButton, CdrImg, CdrText } from '@rei/cedar';
import data from './model';

const heading = computed(() => data?.heading);
const subheading = computed(() => data?.subheading);
const coupons = computed(() => data?.coupons);
</script>

<style lang="scss">
.mem-coupons {
  @include cdr-container;
}
.mem-coupons {
  margin-top: $cdr-space-three-x;
  margin-bottom: $cdr-space-three-x;
  @include cdr-md-mq-up {
    margin-bottom: $cdr-space-four-x;
  }
}
.mem-coupons__heading {
  @include cdr-text-heading-serif-600;
  @include cdr-md-mq-up {
    @include cdr-text-heading-serif-800;
    margin-bottom: $cdr-space-three-quarter-x;
  }
}
.mem-coupons__subheading {
  @include cdr-md-mq-up {
    margin-bottom: $cdr-space-two-x;
  }
}
.mem-coupons__coupons {
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: $cdr-space-one-x;
  @include cdr-md-mq-up {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: $cdr-space-three-x;
  }
}
.coupon {
  display: flex;
  flex-direction: column;
  margin-bottom: $cdr-space-two-x;
  padding: $cdr-space-one-x 0;
  @include cdr-md-mq-up {
    margin-bottom: 0;
    padding: $cdr-space-half-x 0;
  }
}
.coupon__image-container {
  margin-bottom: $cdr-space-three-quarter-x;
  position: relative;
  @include cdr-md-mq-up {
    max-height: 320px;
  }
}
.coupon__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 1.27;
}
.coupon__coupon-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  transform: translateX(-50%) translateY(-50%);
  @include cdr-md-mq-up {
    width: 275px;
  }
}
.coupon__heading {
  @include cdr-text-heading-serif-600;
  margin-bottom: $cdr-space-three-quarter-x;
}
.coupon__body {
  @include cdr-text-body-300;
  margin-top: 0;
  margin-bottom: $cdr-space-three-quarter-x;

  strong {
    font-weight: 600;
  }
}
.coupon__rights-container {
  position: absolute;
  bottom: 16px;
  left: 14px;
  display: flex;
  gap: $cdr-space-half-x;
}
.coupon__rights-image {
  width: 19px;
}
.coupon__rights-text {
  color: $cdr-color-background-primary;
  font-size: $cdr-text-heading-serif-200-size;
  font-weight: $cdr-text-heading-serif-strong-600-weight;
}
.coupon__cta {
  justify-content: center;
  @include cdr-md-mq-up {
    width: fit-content;
  }
}
</style>
